<script>

import Utils from '../../common/Utils';
import CommonConstants from '../../common/Constants';
import Service from '@/services/movement-instruction';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue'
import GenericBooleanDropdown from '../../components/generic/GenericBooleanDropdown.vue';
import { useVuelidate } from "@vuelidate/core";
import { required } from '@vuelidate/validators';

export default {
    setup: () => ({ v$: useVuelidate() }),
    components: 
        {
            ResponsiveButton,
            GenericCustomMasterDataAutocompleteV2,
            GenericBooleanDropdown
        },

    data() {
        return {                            
            filters: {
                referenceDate: Utils.setFirstDayOfMonth(Utils.formatDatePlusMonths(new Date(), -2)),
            },
            siteContract: [],
            showAddDialog: false,
            selectedItems: [],
            editSiteContracts: [],
            addItem: {
                isOutCDep: false,
                isDeleted: false
            },
            submitted: false,
            selectAll: false,
            originalItems: []
        }
    },
    validations(){
    return {
        addItem: {
            idCounterParty: { required },
            idRegistryProduct: { required },
            idRegistryOperationType: { required },
            idRegistryPlant: { required },
            referenceDate: {},
            date: {},
            quantity: {},
            contractNumberReference: {},
            isOutCDep: {},
            incotermCode: {},
            idRegistryInspector: {}   
        } 
    }
  },
    created() {},
    mounted() {       
        this.$store.dispatch('security/setNavbarTitle', 'SiteContracts.page_title');
        this.loadSiteContract();
    },
    computed: {
        constants() {
            return CommonConstants; 
        },
        utils() {
            return Utils;
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        }
    },
    methods: {
        loadSiteContract(){

            let body = {
                referenceDate: Utils.formatDateForAPI(this.filters.referenceDate)
            };

            this.$store.dispatch("generic/setLoading", true);
            this.originalItems = [];
            Service.getSiteContracts(body, response => {   
                this.$store.dispatch("generic/setLoading", false);      
                if(response.success && response.data != null){                      
                    this.siteContract = response.data;
                    
                    if(this.siteContract.length == 0){
                        this.createSiteContracts();                       
                    }          
                    
                    for(let i = 0; i < this.siteContract.length; i++){
                        let item = this.siteContract[i];
                        item.date = item.date ? Utils.dateToCurrentTimeZone(item.date) : null;

                        this.originalItems.push({...item});
                    }

                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            });
        },
        createSiteContracts(){

            let body = {
                referenceDate: Utils.formatDateForAPI(this.filters.referenceDate)
            };

            this.$confirm.require({
                message: this.$t('SiteContracts.creationMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch("generic/setLoading", true);
                    Service.createSiteContracts(body, response => {   
                        this.$store.dispatch("generic/setLoading", false);      
                        if(response.success){
                            Service.getSiteContracts(body, res => {       
                                if(res.success && res.data != null){                      
                                    this.siteContract = res.data;                                      
                                }else{
                                    this.$toast.add({detail: res.message && res.message != '' ? res.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                }
                            });
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});                              
                        }else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    });
                },
                reject: () => {
                    this.$confirm.close();
                }
            })
        },
        cloneContract(data){
            let body = {
                idReferenceRecord: data.id
            };

            this.$confirm.require({
                message: this.$t('SiteContracts.cloneMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch("generic/setLoading", true);
                    Service.cloneSiteContracts(body, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if(response.success){
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
                            this.loadSiteContract();
                        }else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    })
                },
                reject: () => {
                    this.$confirm.close();
                }
            })         
        },
        onContractsRowEditSave(data){
            let sameData = Object.entries(data.data).every(([key, value]) => value === data.newData[key])

            if(sameData) return;

            if(data.data.idMovementInstructionHeader != null){
                this.$confirm.require({
                    message: this.$t('SiteContracts.updateMessage'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.$t('yes'),
                    rejectLabel: this.$t('no'),
                    accept: () => {
                        this._updateMethod(data);
                    },
                    reject: () => {
                        this.$confirm.close();
                    }
                })
            }else{
                this._updateMethod(data);
            }
        },    
        _updateMethod(data){
            this.$store.dispatch("generic/setLoading", true);
            Service.updateSiteContracts(data.newData, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                    
                    if (this.selectedItems.some(i => i.id === data.newData.id)) {
                        
                        this.selectedItems = this.selectedItems.map(item =>item.id === data.newData.id ? data.newData : item);
                    }else{
                        this.$nextTick(() => {
                            const realRow = this.siteContract.find(r => r.id === data.newData.id);

                            if(data.data.idMovementInstructionHeader == null){
                                // 3. Seleziono la riga nella GUI
                                this.selectedItems = [...this.selectedItems, realRow];
                                this.selectedItems = this.selectedItems.map(item => item.id === data.newData.id ? data.newData : item);
                            }                           
                        });
                    }

                    this.loadSiteContract();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        deleteSiteContract(data){
            this.$confirm.require({
                message: this.$t('SiteContracts.deleteMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch("generic/setLoading", true);
                    Service.deleteSiteContracts(data.id, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if(response.success){
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                            this.loadSiteContract();
                        }else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    })
                },
                reject: () => {
                    this.$confirm.close();
                }
            })         
        },
        onSaveNewItem(valid){

            if (!valid){
                return;
            }       

            this.addItem.referenceDate = Utils.formatDateForAPI(this.filters.referenceDate);

            this.$store.dispatch("generic/setLoading", true);
            Service.addSiteContracts(this.addItem, response => {
                this.showAddDialog = false;
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){               
                    this.loadSiteContract();
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        send(){

            if(this.selectedItems == null || this.selectedItems.length <= 0){
                return;
            }

            let body = { contractList: [] }

            for(let i = 0; i < this.selectedItems.length; i++){
                body.contractList.push(this.selectedItems[i]);
            }

            this.$confirm.require({
                message: this.$t('SiteContracts.sendMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch("generic/setLoading", true);
                    Service.sendSiteContracts(body, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if(response.success){
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
                            this.loadSiteContract();
                            this.selectedItems = [];
                        }else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    })
                },
                reject: () => {
                    this.$confirm.close();
                }
            })   
        },
        hasAllocation(row) {
            if (!row) return false;
            const alloc = row.idMovementInstructionHeader;
            if (alloc === null || alloc === undefined) return false;
            return true; // numeri/boolean considerati valorizzati
        },

        // ritorna true se la riga è selezionabile
        isSelectable(row) {
            return !this.hasAllocation(row);
        },

        // handler intelligente per update:selection
        onUpdateSelection(newSelection) {
            
            // se non ci sono righe (deselezione totale)
            if (!newSelection || (Array.isArray(newSelection) && newSelection.length === 0)) {
                this.selectedItems = [];
                this.selectAll = false;
                return;
            }

            // se newSelection è array
            if (Array.isArray(newSelection)) {
            const totalRows = Array.isArray(this.siteContract) ? this.siteContract.length : 0;
            const selectableRows = (this.siteContract || []).filter(r => this.isSelectable(r));

            // CASO: utente ha premuto SELECT-ALL (PrimeVue invia tutte le righe)
            if (newSelection.length === totalRows) {
                
                this.selectAll = !this.selectAll;
                if(this.selectAll){
                    this.selectedItems = selectableRows.slice();
                }else{
                    this.selectedItems = [];
                }
                return;
            }

            // ALTRI CASI: selezione manuale singola/multipla -> filtra
            this.selectedItems = newSelection.filter(item => this.isSelectable(item));
            } else {
            // caso singola selection (rare con multiple mode)
            this.selectedItems = this.isSelectable(newSelection) ? newSelection : [];
            }
        },
        isEditable(data){
            data.idMovementInstructionHeader == null;
        },
        onRowEditInit(data){
            data.newData.date = Utils.setLastDayOfMonth(this.filters.referenceDate);
        },
        onRowEditCancel(data){
            var item = this.originalItems.find(x => x.id == data.newData.id);
            var newItem = this.siteContract.find(x => x.id == data.newData.id);
            newItem.idCounterParty = item.idCounterParty;
            newItem.idRegistryProduct = item.idRegistryProduct;
            newItem.idRegistryOperationType = item.idRegistryOperationType;
            newItem.idRegistryPlant = item.idRegistryPlant;
            newItem.date = item.date;
            newItem.quantity = item.quantity;
            newItem.contractNumberReference = item.contractNumberReference;
            newItem.isOutCDep = item.isOutCDep;
            newItem.incotermCode = item.incotermCode;
            newItem.idRegistryInspector = item.idRegistryInspector;
            newItem.note = item.note;
        }
    }
}
</script>

<template>
    <main>
        <Dialog v-model:visible="showAddDialog" modal :style="{width: '20vw'}">
            <div class="field">
                <label for="counterParty">{{ $t('SiteContractOperations.counterParty') }}</label>
                <GenericCustomMasterDataAutocompleteV2
                v-model="addItem.idCounterParty"
                api="masterdata/company-combo" 
                name="masterdata-company-combo" 
                class="w-full p-inputtext-sm mt-1"/>

                <div v-if="(v$.addItem.idCounterParty.$invalid) || v$.addItem.idCounterParty.$pending.$response">
                    <small class="p-error" v-for="error in v$.addItem.idCounterParty.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>

            <div class="field">
                <label for="registryProduct">{{ $t('SiteContractOperations.registryProduct') }}</label>
                <GenericCustomMasterDataAutocompleteV2
                class="w-full p-inputtext-sm mt-1"
                v-model="addItem.idRegistryProduct"
                api="masterdata/product-combo" 
                name="masterdata-product-combo" />

                <div v-if="(v$.addItem.idRegistryProduct.$invalid) || v$.addItem.idRegistryProduct.$pending.$response">
                    <small class="p-error" v-for="error in v$.addItem.idRegistryProduct.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>

            <div class="field">
                <label for="registryOperation">{{ $t('SiteContractOperations.registryOperation') }}</label>
                <GenericCustomMasterDataAutocompleteV2
                class="w-full p-inputtext-sm mt-1"
                v-model="addItem.idRegistryOperationType"
                api="movement-instruction/user-role-operation-type-combo" 
                name="movement-instruction-user-role-operation-type-combo" />

                <div v-if="(v$.addItem.idRegistryOperationType.$invalid) || v$.addItem.idRegistryOperationType.$pending.$response">
                    <small class="p-error" v-for="error in v$.addItem.idRegistryOperationType.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>

            <div class="field">
                <label for="registryPlant">{{ $t('SiteContractOperations.registryPlant') }}</label>
                <GenericCustomMasterDataAutocompleteV2
                class="w-full p-inputtext-sm mt-1"
                v-model="addItem.idRegistryPlant"
                api="masterdata/registry-plant-combo" 
                name="masterdata-plant-combo" />

                <div v-if="(v$.addItem.idRegistryPlant.$invalid) || v$.addItem.idRegistryPlant.$pending.$response">
                    <small class="p-error" v-for="error in v$.addItem.idRegistryPlant.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>

            <div class="field">
                <label for="contractNumberReference">{{$t('SiteContracts.contractNumberReference')}}</label>
                <InputText class="w-full" v-model="this.addItem.contractNumberReference" />
            </div>
            
            <div class="field">
                <label for="isOutCDep">{{$t('SiteContracts.isOutCDep')}}</label>
                <GenericBooleanDropdown class="w-full" v-model="this.addItem.isOutCDep" />
            </div>

            <div class="field">
                <label for="incotermCode">{{ $t('SiteContracts.incotermCode') }}</label>
                <GenericCustomMasterDataAutocompleteV2
                class="p-inputtext-sm w-full"
                v-model="addItem.incotermCode"
                api="masterdata/incoterm-combo" 
                name="masterdata-incoterm-combo" />  
            </div>

            <div class="field">
                <label for="registryInspector">{{ $t('SiteContracts.registryInspector') }}</label>
                <GenericCustomMasterDataAutocompleteV2
                class="p-inputtext-sm w-full"
                v-model="addItem.idRegistryInspector"
                api="masterdata/inspector-combo" 
                name="masterdata-inspector-combo" />  
            </div>

            <template #footer>
                <ResponsiveButton :label="$t('btn.save')" icon="pi pi-save" class="my-2 p-button-outlined" @click="onSaveNewItem((!v$.$invalid))" />
            </template>

        </Dialog>

        <div class="grid" style="margin-left: 0.2%">
            <div class="col-4 lg:col-2">
                <label for="monthDate">{{$t('bookOut.monthReferenceDate')}}</label>
                <Calendar
                class="p-inputtext-sm w-full"
                placeholder="__/__/____"
                v-model="this.filters.referenceDate"
                name="referenceDate" dateFormat="mm/yy" :showTime="false"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" 
                view="month" />
            </div>
            
            <div class="col-12 lg:col-4 mt-2">
                <ResponsiveButton type="button" icon="pi pi-replay" class="p-button-sm mx-2 my-3" :label="$t('btn.load')" severity="secondary" @click="loadSiteContract" />              
            </div> 
            
            <div class="col-12 lg:col-4 mt-2">
                <ResponsiveButton type="button" icon="pi pi-plus" class="p-button-sm p-button-outlined mx-2 my-3" :label="$t('btn.add')" severity="secondary" @click="showAddDialog = true" />
                <ResponsiveButton type="button" icon="pi pi-send" class="p-button-sm p-button-solid p-button-success mx-2 my-3" 
                :label="$t('btn.send')" :disabled="this.selectedItems == null || this.selectedItems.length == 0" @click="send" />
            </div>
        </div>

        <div class="col-12 data" style="margin-top: 2vh;">
            <div class="grid">
                <div class="col-12">
                    <DataTable @row-edit-init="onRowEditInit" @row-edit-cancel="onRowEditCancel" stripedRows v-model:selection="selectedItems" :value="siteContract" scrollable :responsiveLayout="'stack'" scrollHeight="flex" sortMode="single" 
                    :sortOrder="1" dataKey="id" editMode="row" v-model:editing-rows="editSiteContracts" @row-edit-save="onContractsRowEditSave" @update:selection="onUpdateSelection">

                        <Column style="min-width: 50px;" class="selection-column" selectionMode="multiple" />
                        <Column style="min-width: 20px;" :rowEditor="true" />
                            
                        <Column class="button-column" :exportable="false" :reorderableColumn="false" style="min-width: 100px;">
                            <template #body="slotProps">
                                <Button v-tooltip="$t('btn.clone')" icon="pi pi-clone" class="p-button-sm p-button-rounded p-button-outlined"
                                @click="cloneContract(slotProps.data)" />
                                <Button v-tooltip="$t('btn.delete')" icon="pi pi-trash" class="mx-2 p-button-sm p-button-rounded p-button-warning" 
                                @click="deleteSiteContract(slotProps.data)" v-if="slotProps.data.idMovementInstructionHeader == null"/>
                            </template>
                        </Column>

                        <Column style="min-width: 150px;" field="voyageNumber" :header="$t('SiteContracts.voyageNumber')" />

                        <Column style="min-width: 220px;" field="counterParty" :header="$t('SiteContractOperations.counterParty')">
                            <template #body="{data, field}">
                                <span> {{data[field] }} </span>
                            </template>
                            <template #editor="{data, field}">
                                <GenericCustomMasterDataAutocompleteV2
                                    class="p-inputtext-sm w-full"
                                    v-model="data.idCounterParty"
                                    api="masterdata/company-combo" 
                                    name="masterdata-company-combo" 
                                    v-if="isEditable(data)" />
                                    <span v-else>{{ data[field] }}</span>                                
                            </template>
                        </Column>

                        <Column style="min-width: 200px;" field="registryProduct" :header="$t('SiteContractOperations.registryProduct')">
                            <template #body="{data, field}">
                                <span> {{data[field] }} </span>
                            </template>
                            <template #editor="{ data}">
                                <GenericCustomMasterDataAutocompleteV2
                                    class="p-inputtext-sm w-full"
                                    v-model="data.idRegistryProduct"
                                    api="masterdata/product-combo" 
                                    name="masterdata-product-combo" />                                
                            </template>
                        </Column>

                        <Column style="min-width: 220px;" field="registryOperationType" :header="$t('SiteContractOperations.registryOperation')">
                            <template #body="{data, field}">
                                <span> {{data[field] }} </span>
                            </template>
                            <template #editor="{ data}">
                                <GenericCustomMasterDataAutocompleteV2
                                    class="p-inputtext-sm w-full"
                                    v-model="data.idRegistryOperationType"
                                    api="movement-instruction/user-role-operation-type-combo" 
                                    name="movement-instruction-user-role-operation-type-combo" />                                
                            </template>
                        </Column>

                        <Column style="min-width: 130px;" field="registryPlant" :header="$t('SiteContractOperations.registryPlant')">
                            <template #body="{data, field}">
                                <span> {{data[field] }} </span>
                            </template>
                            <template #editor="{ data}">
                                <GenericCustomMasterDataAutocompleteV2
                                    class="p-inputtext-sm w-full"
                                    v-model="data.idRegistryPlant"
                                    api="masterdata/registry-plant-combo" 
                                    name="masterdata-plant-combo" />                                
                            </template>                    
                        </Column>

                        <Column style="min-width: 130px;" field="date" :header="$t('SiteContracts.date')">
                            <template #body="{data, field}">
                                <span> {{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}} </span>
                            </template>
                            <template #editor="{ data, field }">   
                                <Calendar 
                                    class="w-full" 
                                    v-model="data[field]" 
                                    dateFormat="dd/mm/yy" 
                                    placeholder="dd/mm/yyyy" 
                                    :showButtonBar="true" :yearNavigator="true" />                             
                            </template>  
                        </Column>

                        <Column style="min-width: 150px;" field="quantity" :header="$t('SiteContracts.quantity')">
                            <template #body="{data, field}">
                                <span> {{data[field] != null ? utils.formatDecimal(data[field], 3) : null}} </span>
                            </template>
                            <template #editor="{ data, field }">
                                <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0" :maxFractionDigits="3" />
                            </template>
                        </Column>

                        <Column style="min-width: 150px;" field="contractNumberReference" :header="$t('SiteContracts.contractNumberReference')">
                            <template #body="{data, field}">
                                <span> {{data[field]}} </span>
                            </template>
                            <template #editor="{ data, field }">
                                <InputText v-model="data[field]" class="w-full" />
                            </template>
                        </Column>

                        <Column style="min-width: 100px;" field="isOutCDep" :header="$t('SiteContracts.isOutCDep')">
                            <template #body="{data, field}">
                                <span> {{data[field] ? "OUTC/DEP": null}} </span>
                            </template>
                            <template #editor="{ data, field}">
                                <GenericBooleanDropdown class="w-full" v-model="data[field]" />                                
                            </template>   
                        </Column>

                        <Column style="min-width: 150px;" field="incotermCode" :header="$t('SiteContracts.incotermCode')">
                            <template #body="{data, field}">
                                <span> {{data[field]}} </span>
                            </template>
                            <template #editor="{ data, field}">
                                <GenericCustomMasterDataAutocompleteV2
                                    class="p-inputtext-sm w-full"
                                    v-model="data[field]"
                                    api="masterdata/incoterm-combo" 
                                    name="masterdata-incoterm-combo" />                                
                            </template>  
                        </Column>

                        <Column style="min-width: 150px;" field="registryInspector" :header="$t('SiteContracts.registryInspector')">
                            <template #body="{data, field}">
                                <span> {{data[field]}} </span>
                            </template>
                            <template #editor="{ data}">
                                <GenericCustomMasterDataAutocompleteV2
                                    class="p-inputtext-sm w-full"
                                    v-model="data.idRegistryInspector"
                                    api="masterdata/inspector-combo" 
                                    name="masterdata-inspector-combo" />                                
                            </template>   
                        </Column>

                        <Column style="min-width: 150px;" field="note" :header="$t('SiteContracts.note')">
                            <template #body="{data, field}">
                                <span> {{data[field]}} </span>
                            </template>
                            <template #editor="{ data, field }">
                                <Textarea v-model="data[field]" class="w-full" />
                            </template>  
                        </Column>                      
                    </DataTable>
                </div>
            </div>
         </div>
    </main>
</template>
